import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogActionsRoot: {
      paddingRight: 20,
      paddingBottom: 20,
    },
    btnNo: {
      backgroundColor: "#bfbfbf",
      color: "#fff",
      "&:hover": {
        backgroundColor: "#999999",
      },
    },
  }),
);
